
import { createContext, useReducer } from "react";
import StatistiqueReducer from "./StatistiqueReducer";

const INITIAL_STATE = {
    statistiques: {},
    isFetchingGet: false,
    errorGet: false,
};


export const StatistiqueContext = createContext(INITIAL_STATE);

export const StatistiqueContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(StatistiqueReducer, INITIAL_STATE);
    
    return (
      <StatistiqueContext.Provider
        value={{
          statistiques: state.statistiques,
          message: state.message,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          dispatch,
        }}
      >
        {children}
      </StatistiqueContext.Provider>
    );
  };